// extracted by mini-css-extract-plugin
export var home = "index-module--home--1mM2Q";
export var footer = "index-module--footer--1Lu6x";